import { amber } from "@mui/material/colors";

export type customColorType = "blue" | "orange" | "yellow" | "green" | "berry" | "pink" | "red";
export type customThemeMode = "light" | "dark";
export type customNavMode = "white" | "transparent" | "dark";

interface ICustomColor {
    blue: string,
    orange: string,
    yellow: string,
    green: string,
    berry: string,
    pink: string,
    red: string,
    secondary: string,
    error: string,
    warning: string,
    info: string,
    success: string,
}

export const customColor: ICustomColor = {
    blue: "#1976d2",
    orange: "#ff5722",
    yellow: amber.A700,
    green: "#009688",
    berry: "rgb(103, 58, 183)",
    pink: "rgb(214, 114, 199)",
    red: "rgb(217, 68, 66)",
    secondary: "#9c27b0",
    error: "#d9534f",
    warning: "#ed6c02",
    info: "#0288d1",
    success: "#5cb85c"
}
export const borderRadius = 8;
export const customBlack = "rgba(0, 0, 0, 0.87)";
export const customFontSize = 10;

/*
xSmall :
customFontSize = 10

small  : 
customFontSize = 11

mideum : 
customFontSize = 12


large : 
customFontSize = 13

xlarge : 
customFontSize = 14
*/
